var _style, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "350px",
    height: "650px",
    viewBox: "0 0 350 650",
    style: {
      enableBackground: "new 0 0 350 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#004666;}\n\t.st2{fill:#E6ECF1;}\n\t.st3{fill:#004666;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 350,
    height: 650
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 118.5,
    cy: 200.5,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 216,
    cy: 496,
    r: 14.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 240.5,
    cy: 465.5,
    r: 32
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 172,
    cy: 314,
    r: 65
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 239.5,
    cy: 98.5,
    r: 10.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 92,
    cy: 533,
    r: 35
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 172,
    cy: 314,
    r: 70.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M169.88,314l-21.44-21.44c-1.41-1.41,0.71-3.54,2.12-2.12L172,311.88l21.44-21.44 c1.41-1.41,3.54,0.71,2.12,2.12L174.12,314l21.44,21.44c1.41,1.41-0.71,3.54-2.12,2.12L172,316.12l-21.44,21.44 c-1.41,1.41-3.54-0.71-2.12-2.12L169.88,314z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndFalse);
export default __webpack_public_path__ + "static/media/endFalse.673b5fc0a7008dfdd0ca4da77cb70a1d.svg";
export { ForwardRef as ReactComponent };